import * as React from 'react';
import { ReactNode } from 'react';

const defaultTitle = "";

interface DocumentTitleProps {
    title?: string;
    children?: ReactNode;
}

const DocumentTitle = ({ title = defaultTitle, children }: DocumentTitleProps) => {

    React.useEffect(() => {
        document.title = title;

        return () => {
            document.title = defaultTitle;
        }
    }, [title]);

    if (children)
        return <>{children}</>;

    return null;
}

export default DocumentTitle;
